module.exports = __webpack_public_path__ + "media/images/background_offer-800w-044472b8.jpg";